module.exports = {"pt-BR":{"realEstateAdmin":{"navbar":{"contracts":"Contratos","cnab":"CNAB"}}}}